// extracted by mini-css-extract-plugin
export default {"gameContainer":"style_gameContainer__DHJtw","textContainer":"style_textContainer__xfZL0","hideOnLarge":"style_hideOnLarge__F5t3u","hideOnSmall":"style_hideOnSmall__61gAI"};